import React from 'react';
import { ChevronDown } from 'lucide-react';

const inputCls = (err) =>
  `block min-h-[48px] w-full rounded-2xl border bg-navy px-4 py-3 text-base text-white placeholder:text-ink/50 transition-colors focus:outline-none focus:ring-2 focus:ring-brand/40 ${
    err ? 'border-nope' : 'border-line focus:border-brand'
  }`;

const FieldShell = ({ id, label, error, children }) => (
  <div>
    <label htmlFor={id} className="mb-1.5 block text-sm font-semibold text-white">{label}</label>
    {children}
    {error && <p id={`${id}-error`} className="mt-1.5 text-sm text-nope" data-testid={`${id}-error`}>{error}</p>}
  </div>
);

export const TextField = ({ id, label, error, ...props }) => (
  <FieldShell id={id} label={label} error={error}>
    <input id={id} name={id} className={inputCls(error)} aria-invalid={!!error}
           aria-describedby={error ? `${id}-error` : undefined} data-testid={`apply-${id}-input`} {...props} />
  </FieldShell>
);

export const TextArea = ({ id, label, error, ...props }) => (
  <FieldShell id={id} label={label} error={error}>
    <textarea id={id} name={id} rows={3} className={`${inputCls(error)} resize-y`} aria-invalid={!!error}
              aria-describedby={error ? `${id}-error` : undefined} data-testid={`apply-${id}-input`} {...props} />
  </FieldShell>
);

export const SelectField = ({ id, label, error, options, ...props }) => (
  <FieldShell id={id} label={label} error={error}>
    <div className="relative">
      <select id={id} name={id} className={`${inputCls(error)} appearance-none pr-11`} aria-invalid={!!error}
              aria-describedby={error ? `${id}-error` : undefined} data-testid={`apply-${id}-select`} {...props}>
        <option value="">Bitte auswählen</option>
        {options.map((o) => <option key={o} value={o}>{o}</option>)}
      </select>
      <ChevronDown size={18} className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 text-ink" aria-hidden="true" />
    </div>
  </FieldShell>
);


export const OptionGroup = ({ id, label, options, value, onChange, error }) => (
  <fieldset aria-describedby={error ? `${id}-error` : undefined}>
    <legend className="font-display text-xl font-bold text-white">{label}</legend>
    <div className="mt-5 grid gap-3" role="radiogroup">
      {options.map((o, i) => {
        const selected = value === o;
        return (
          <label key={o} data-testid={`apply-${id}-option-${i}`}
                 className={`flex min-h-[56px] cursor-pointer items-center gap-3 rounded-2xl border px-5 py-3 text-base transition-colors ${selected ? 'border-brand bg-leaf text-white' : 'border-line bg-paper text-white/85 hover:border-brand/50'}`}>
            <input type="radio" name={id} value={o} checked={selected} onChange={() => onChange(o)}
                   className="h-5 w-5 shrink-0 accent-brand" id={i === 0 ? id : undefined} />
            {o}
          </label>
        );
      })}
    </div>
    {error && <p id={`${id}-error`} className="mt-2 text-sm text-nope" data-testid={`${id}-error`}>{error}</p>}
  </fieldset>
);
